import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { MapModel,States,regionMapAR ,ResultGoogle, mendozaCities, distributorCities } from './model/map-model';
import { SesionService } from 'src/app/core/service/sesion.service';
import { PotentialCustomer } from 'src/app/pages/potential-customer/model/potential-customer';
import { debounceTime, distinctUntilChanged, Observable } from 'rxjs';
import { MapService } from './service/map.service';
import { GoogleMap } from '@angular/google-maps';
import { ShadowScrollService } from 'src/app/core/service/utils/shadow-scroll.service';
import { noEmojisValidator } from 'src/app/core/service/utils/regex-list.regex';
import { animate, style, transition, trigger } from "@angular/animations";

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("150ms", style({ opacity: 1 })),
      ]),
      transition(":leave", [animate("150ms", style({ opacity: 0 }))]),
    ]),
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: MapComponent,
      multi: true,
    },
  ],
})
export class MapComponent implements OnInit, ControlValueAccessor {
  @Input()
  required: boolean;

  @Input()
  submitted: boolean;
  mapForm: FormGroup;
  sesionData: PotentialCustomer | null;
  location!: MapModel;
  showStateWarning: boolean;
  stateWarning: string;
  expression: RegExp = /^[A-Za-záéíóúüñÁÉÍÓÚÜÑ\d\s]+\s\d+,\s[A-Za-záéíóúüñÁÉÍÓÚÜÑ\d\s]+,\s[A-Za-záéíóúüñÁÉÍÓÚÜÑ\d\s]+$/;
  isCABA: boolean = false;
  isBSAS: boolean = false;
  isMendoza: boolean = false;
  directionWarning: boolean = false;
  phase: number;
  showDistributorCheckbox: boolean = false;
  editingMarker: boolean = false;
  provincias = States;
  mapOptions: any = {
    zoom: 17,
    mapTypeControlOptions: { mapTypeIds: [] },
    disableDefaultUI: true,
    mapTypeControl: true,
    scaleControl: true,
    mapTypeId: 'roadmap',
    clickableIcons: false,
    draggableCursor: 'crosshair',
  };
  zoom: number;
  markerPosition: any = null;
  apiLoaded: Observable<boolean>;
  showErrorConfirm: boolean = false;

  onChange!: (value: any) => void;

  constructor(
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    private sesion: SesionService,
    private mapService: MapService,
    public shadowScroll: ShadowScrollService,
  ) {
    this.phase = 1;
    this.zoom = 17;
    this.apiLoaded = mapService.googleMapsDinamicApi();
    this.submitted = false;
    this.required = false;
    this.showStateWarning = false;
    this.stateWarning = '';
    this.sesionData = this.sesion.getItem('potential_customer');
    const provincefiltered = this.provincias.find(province => province.value.toUpperCase() == this.sesionData?.location.state.toUpperCase());
    console.log('provincias', provincefiltered);
    this.mapForm = this.fb.group({
      locationStreet: [
        this.sesionData ? this.sesionData.location.street : '',
        [Validators.required, Validators.maxLength(60),noEmojisValidator],
      ],
      locationStreetNumber: [this.sesionData ? this.sesionData.location.streetNumber : '', [Validators.maxLength(10), (control: import('@angular/forms').AbstractControl) => {
        const v = control.value;
        return (v === '' || v === null || v === undefined || Number(v) <= 0) ? { invalidStreetNumber: true } : null;
      }]],
      locationCity: [this.sesionData ? this.sesionData.location.city : '', [Validators.required,noEmojisValidator]],
      locationState: [this.sesionData ? provincefiltered.value : '', [Validators.required,noEmojisValidator]],
      entreCalles: [this.sesionData ? this.sesionData.location.entreCalles : '', [Validators.maxLength(40),noEmojisValidator]],
      depto: [this.sesionData ? this.sesionData.location.depto : '', [Validators.maxLength(10),noEmojisValidator]],
      zipCode: [
        this.sesionData ? this.sesionData.location.postCode : '',
        [Validators.required, Validators.maxLength(10)],
      ],
      noneNumberStreet: [false],
      showDistributorFields: [!!(this.sesionData?.location?.erpDistributorClientId && this.sesionData?.location?.erpDistributorClientName)],
      erpDistributorClientId: [this.sesionData?.location?.erpDistributorClientId ?? ''],
      erpDistributorClientName: [this.sesionData?.location?.erpDistributorClientName ?? ''],
    });
    this.detectChangeForm();
    this.mapForm.controls['zipCode'].valueChanges.subscribe((value) => {
      if (this.location && value != '') {
        this.location.postCode = value;
        this.dispatchChange();
      }
    });
  }

  detectChangeForm() {
    const formControls = [
      "locationCity",
      "locationStreet",
      "locationState",
      "locationStreetNumber",
      "depto",
      "zipCode",
    ];
    formControls.forEach((controlName) => {
      this.mapForm.controls[controlName].valueChanges
        .pipe(debounceTime(600), distinctUntilChanged())
        .subscribe((value) => {
          this.showErrorConfirm = false;
          if (this.areAllControlsValid(formControls)) {
            this.validateDirec();
          }else {
            this.onChange(null);
          }
        });
    });
  }

  areAllControlsValid(controlNames: string[]): boolean {
    return controlNames.every((controlName) => this.mapForm.controls[controlName].valid);
  }

  ngOnInit(): void {
    this.formDetectChanges();
    if (this.sesionData) {
      const savedCity = this.sesionData.location.city;
      const savedState = this.sesionData.location.state;
      if (savedState && savedState.toUpperCase().includes('MENDOZA')) {
        this.isMendoza = true;
      }
      this.updateDistributorCheckboxVisibility(savedCity);
      if (this.mapForm.controls['showDistributorFields'].value) {
        this.mapForm.controls['erpDistributorClientId'].setValidators([Validators.required]);
        this.mapForm.controls['erpDistributorClientName'].setValidators([Validators.required]);
        this.mapForm.controls['erpDistributorClientId'].updateValueAndValidity({ emitEvent: false });
        this.mapForm.controls['erpDistributorClientName'].updateValueAndValidity({ emitEvent: false });
      }
      this.validateDirec();
    }
  }

  validateDirec(coordinates?: { lat: number; lng: number }) {
    let street = this.mapForm.controls['locationStreet'].value;
    let streetNumber = this.mapForm.controls['locationStreetNumber'].value;
    let state = this.mapForm.controls['locationState'].value;
    console.log('durect ' ,state);
    let city = this.mapForm.controls['locationCity'].value;
    let cp = this.mapForm.controls['zipCode'].value;
    let direction = street + ' ' + streetNumber + ', ' + city + ', ' + cp + ', '+ state + ', Argentina';
    this.parseDirec(direction, coordinates);
    this.directionWarning = false;
  }

  parseDirec(direccion: string, coordinates?: { lat: number; lng: number }) {
    let direcParse = this.replaceSpacesWithPlus(direccion);
    this.mapService.getDirection(direcParse).subscribe((data) => {
      if (data.status == 'OK') {
        let street: boolean = false;
        let postalCode: boolean = false;
        this.isCABA = false;
        let resultTypeStreetNumber = data.results[0].address_components.find((result: any) =>
          result.types.includes('street_number'),
        );
        if (resultTypeStreetNumber) {
          street = true;
        }
        let resultTypePostalCode = data.results[0].address_components.find((result: any) =>
          result.types.includes('postal_code'),
        );
        if (resultTypePostalCode) {
          postalCode = true;
        }
        if (!coordinates) {
          this.markerPosition = {
            lat: data.results[0].geometry.location.lat,
            lng: data.results[0].geometry.location.lng,
          };
          this.mapOptions.center = this.markerPosition;
          this.zoom = 17;
        }
        if (!street || !postalCode) {
          this.mapService
            .getDirectionWithCordinates(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng)
            .subscribe((dataTwo) => {
              let postCode: string = '';
              for (let result of dataTwo.results[0].address_components) {
                if (result.types.includes('postal_code')) postCode = result.long_name;
              }
              this.parseResultMap(data, postCode, coordinates);
            });
        } else {
          this.parseResultMap(data, undefined, coordinates);
        }
      } else {
        this.showErrorConfirm = true;
        this.onChange(null);
        this.cd.detectChanges();
      }
    });
    this.cd.detectChanges();
  }

  parseResultMap(data: ResultGoogle, postCode?: string, coordinates?: { lat: number; lng: number }) {
    let streetNumber = '',
      route = '',
      locality = '',
      country = '',
      postalCode = '',
      state = '';
    for (let result of data.results[0].address_components) {
      switch (true) {
        case result.types.includes('street_number'):
          streetNumber = result.long_name;
          break;
        case result.types.includes('route'):
          route = result.long_name;
          break;
        case result.types.includes('locality'):
          locality = result.long_name;
          this.validateCaba(result.short_name);
          break;
        case result.types.includes('administrative_area_level_1'):
          state = result.long_name;
          break;
        default:
          break;
      }
    }
    if (streetNumber == '') {
      streetNumber = this.mapForm.controls['locationStreetNumber'].value;
    }
    let locationDto: MapModel = {
      address: data.results[0].formatted_address,
      street: route,
      streetNumber: Number(streetNumber),
      state: this.removeProvincia(state),
      postCode: '',
      city: locality != '' ? locality : this.mapForm.controls['locationCity'].value,
      entreCalles: this.mapForm.controls['entreCalles'].value,
      depto: this.mapForm.controls['depto'].value,
      coordinates: {
        lon: coordinates ? coordinates.lng : data.results[0].geometry.location.lng,
        lat: coordinates ? coordinates.lat : data.results[0].geometry.location.lat,
      },
      erpDistributorClientId: (this.showDistributorCheckbox && this.mapForm.controls['showDistributorFields'].value)
        ? this.mapForm.controls['erpDistributorClientId'].value
        : undefined,
      erpDistributorClientName: (this.showDistributorCheckbox && this.mapForm.controls['showDistributorFields'].value)
        ? this.mapForm.controls['erpDistributorClientName'].value
        : undefined,
    };
    if (!locationDto.postCode) {
      locationDto.postCode = this.mapForm.controls['zipCode'].value;
      locationDto.street = route ?? this.mapForm.controls['locationStreet'].value;
    }
    this.location = locationDto;
    this.dispatchChange();
  }

  validateCaba(city: string) {
    if (city == 'CABA') {
      this.isCABA = true;
    }
  }

  borrarLetras(cadena: string): string {
    return cadena.replace(/[^\d]/g, '');
  }

  removeProvincia(text: string): string {
    return text.replace(/Provincia de /g, '');
  }

  writeValue(obj: any): void {
    this.location = obj;
  }


  mapState(state: string): void {
    const upperState = state.toUpperCase();
    console.log('upperSTate',upperState);
    const regionMap = regionMapAR;
  
    const match = regionMap.find(region =>
      region.aliases.some(alias => upperState.includes(alias))
    );
    console.log('match',match);
  
  
    if (match) {
      this.mapForm.controls['locationState'].setValue(match.name);
    } else {
      this.mapForm.controls['locationState'].reset();
    }
  }
  

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {}

  /**
   * Fuerza una evaluación sincrónica del estado del formulario.
   * El padre debe llamar este método antes de verificar su propia validez en onSubmit,
   * para evitar que el debounceTime deje datos obsoletos en el control CVA.
   */
  validate(): void {
    if (!this.mapForm.valid) {
      this.onChange(null);
      this.cd.detectChanges();
      return;
    }
    if (this.location) {
      this.dispatchChange();
    } else {
      this.onChange(null);
      this.cd.detectChanges();
    }
  }

  dispatchChange() {
    if (
      this.location &&
      this.validateAndinaState(this.location.state, this.location.coordinates) &&
      this.location.postCode &&
      (this.location.streetNumber ?? 0) > 0 &&
      this.location.entreCalles.length > 3 &&
      this.location.entreCalles.length < 40 &&
      (this.location.depto.length <= 10 || !this.location.depto) &&
      this.mapForm.valid
    ) {
      this.location.street = (this.location.street && this.location.street.trim() !== "") 
      ? this.location.street 
      : this.mapForm.controls['locationStreet'].value;      
      this.onChange(this.location);
    } else {
      this.cd.detectChanges();
      this.onChange(null);
    }
  }

  replaceSpacesWithPlus(text: string): string {
    return text.replace(/\s+/g, '+');
  }

  removeCommas(text: string): string {
    return text.replace(/,/g, '');
  }

  formDetectChanges() {
    this.mapForm.controls['entreCalles'].valueChanges.subscribe((val) => {
      if (this.location) {
        this.location.entreCalles = this.mapForm.controls['entreCalles'].value;
        this.dispatchChange();
      }
    });

    this.mapForm.controls['depto'].valueChanges.subscribe((val) => {
      if (this.location) {
        this.location.depto = this.mapForm.controls['depto'].value;
        this.dispatchChange();
      }
    });

    this.mapForm.controls['erpDistributorClientId'].valueChanges.subscribe((val) => {
      if (this.location) {
        this.location.erpDistributorClientId = val;
        this.dispatchChange();
      }
    });

    this.mapForm.controls['erpDistributorClientName'].valueChanges.subscribe((val) => {
      if (this.location) {
        this.location.erpDistributorClientName = val;
        this.dispatchChange();
      }
    });

    this.mapForm.controls['showDistributorFields'].valueChanges.subscribe((show: boolean) => {
      if (show) {
        this.mapForm.controls['erpDistributorClientId'].setValidators([Validators.required]);
        this.mapForm.controls['erpDistributorClientName'].setValidators([Validators.required]);
      } else {
        this.mapForm.controls['erpDistributorClientId'].clearValidators();
        this.mapForm.controls['erpDistributorClientName'].clearValidators();
        this.clearDistributorFields();
      }
      this.mapForm.controls['erpDistributorClientId'].updateValueAndValidity({ emitEvent: false });
      this.mapForm.controls['erpDistributorClientName'].updateValueAndValidity({ emitEvent: false });
    });

    this.mapForm.controls['locationCity'].valueChanges.subscribe((city: string) => {
      this.updateDistributorCheckboxVisibility(city);
    });
  }

  updateDistributorCheckboxVisibility(city: string) {
    if (!city || !city.trim()) {
      this.showDistributorCheckbox = false;
      this.mapForm.controls['showDistributorFields'].setValue(false, { emitEvent: false });
      this.clearDistributorFields();
      this.cd.detectChanges();
      return;
    }
    const cityFormatted = city
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    const show = distributorCities.includes(cityFormatted);
    this.showDistributorCheckbox = show;
    if (!show) {
      this.mapForm.controls['showDistributorFields'].setValue(false, { emitEvent: false });
      this.clearDistributorFields();
    }
    this.cd.detectChanges();
  }

  clearDistributorFields() {
    this.mapForm.controls['erpDistributorClientId'].setValue('', { emitEvent: false });
    this.mapForm.controls['erpDistributorClientName'].setValue('', { emitEvent: false });
    if (this.location) {
      this.location.erpDistributorClientId = undefined;
      this.location.erpDistributorClientName = undefined;
      this.dispatchChange();
    }
    this.cd.detectChanges();
  }

  validateAndinaState(state: string, coordinates: { lon: number; lat: number }): boolean {
    if (state) {
      const andinaState = [
        'BUENOS AIRES',
        'CÓRDOBA',
        'ENTRE RÍOS',
        'MENDOZA',
        'SAN JUAN',
        'SAN LUIS',
        'SANTA FE',
        'CHUBUT',
        'NEUQUÉN',
        'LA PAMPA',
        'RÍO NEGRO',
        'SANTA CRUZ',
        'TIERRA DEL FUEGO',
      ];
      let result: boolean = andinaState.filter((x) => state.toLocaleUpperCase().includes(x)).length > 0;
      if (result) {
        this.stateWarning = '';
        this.showStateWarning = false;
        this.isBSAS = false;
        if (state.toLocaleUpperCase().includes('BUENOS AIRES') && coordinates.lon > -59.73) {
          result = false;
          this.isBSAS = true;
        }
          //codigo mendoza city
          if(state.toLocaleUpperCase().includes('MENDOZA')) {
            this.isMendoza = true;
            const formCity = this.mapForm.controls['locationCity'].value;
            if(this.validateMendozaCity(formCity)) {
              this.showStateWarning = true;
              return false;
            }
          }else{
            this.isMendoza = false;
          }
          //termina codigo mendoza city
      } else {
        this.showErrorState(state);
      }
      if (this.isCABA) {
        this.showErrorState(state);
        result = false;
      }
      this.cd.detectChanges();
      return result;
    } else {
      return false;
    }
  }

  showErrorState(state: string) {
    this.stateWarning = state;
    this.showStateWarning = true;
  }

  validateMendozaCity(city: string) {
    if(this.isMendoza) {
      const cityFormatted = city
      .toLocaleLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
      const isValid = mendozaCities.includes(cityFormatted);
      this.showStateWarning = isValid;

      return isValid;
    }else{
      this.showDistributorCheckbox = false;
      this.mapForm.controls['showDistributorFields'].setValue(false, { emitEvent: false });
      this.clearDistributorFields();
      return false;
    }
  }


  @HostListener('scroll', ['$event'])
  onScroll(e: any) {
    this.shadowScroll.scroll(e);
  }

  getAutomaticLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setDirectionWithCordinates(position.coords.latitude, position.coords.longitude);
        },
        (error) => {
              alert("Ocurrió un error desconocido.");
        },
        {
          enableHighAccuracy: true, // intenta precisión máxima
          timeout: 10000,
          maximumAge: 0
        }
      );
    } else {
      alert("La geolocalización no es compatible con este dispositivo.");
    }
  }
  
  

  setDirectionWithCordinates(lat: number, lng: number) {
    this.markerPosition = {
      lat: lat,
      lng: lng,
    };
    this.mapOptions.center = this.markerPosition;
    this.mapService.getDirectionWithCordinates(lat, lng).subscribe((dataTwo) => {
      let googleResult = this.mapResultGoogle(dataTwo);
      this.changueInputWithNewlocation(googleResult);
      this.mapState(googleResult.state)
      this.parseResultMap(dataTwo, googleResult.postalCode, this.markerPosition);
    });
  }

  changueInputWithNewlocation(data: any) {
    this.mapForm.controls['locationStreet'].setValue(data.route);
    this.mapForm.controls['locationStreetNumber'].setValue(data.streetNumber);
    this.mapForm.controls['locationCity'].setValue(data.locality);
    let state: any = '';
    if(data?.state && this.provincias){
      state = this.provincias.filter(state=> {
        return data.state.includes(state.text)
      })
    }else

    console.log('se actualizo , state', state);
    this.mapForm.controls['locationState'].setValue(state);
    this.mapForm.controls['zipCode'].setValue(this.borrarLetras(data.postalCode));
  }

  mapResultGoogle(data: ResultGoogle) {
    let response = {
      streetNumber: '',
      route: '',
      locality: '',
      country: '',
      postalCode: '',
      state: '',
    };
    for (let result of data.results[0].address_components) {
      switch (true) {
        case result.types.includes('street_number'):
          response.streetNumber = result.long_name;
          break;
        case result.types.includes('route'):
          response.route = result.long_name;
          break;
        case result.types.includes('locality'):
          response.locality = result.long_name;
          break;
        case result.types.includes('administrative_area_level_1'):
          response.state = result.long_name;
          break;
        case result.types.includes('administrative_area_level_2'):
          if (!response.state) response.state = result.long_name;
          break;
        case result.types.includes('postal_code'):
          response.postalCode = result.long_name;
          break;
        default:
          break;
      }
    }
    return response;
  }
}
